import { Divider, Grid, Link, Typography, useInfoDrawerControl } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import { AuthFormLayout } from './AuthFormLayout'
import { PasswordForm } from './PasswordForm'
import { PasswordlessLoginForm } from './PasswordlessLoginForm'

export const Login = () => {
  const {
    onClose: hidePasswordForm,
    openTarget: passwordFormLink,
    open: showPasswordForm,
  } = useInfoDrawerControl('password')
  return (
    <AuthFormLayout>
      <Typography variant="h1" gutterBottom>
        <FormattedMessage id="auth.login.sign_in" />
      </Typography>
      {showPasswordForm ? <PasswordForm /> : <PasswordlessLoginForm />}

      <Divider sx={{ my: 3 }} />

      <Grid container justifyContent="center">
        <Typography variant="body2" fontWeight="bold" gutterBottom textAlign="center">
          {showPasswordForm ? (
            <Link to="#" onClick={hidePasswordForm}>
              <FormattedMessage id="auth.login.login_with_phone" />
            </Link>
          ) : (
            <Link to={passwordFormLink}>
              <FormattedMessage id="auth.login.login_with_password" />
            </Link>
          )}
        </Typography>

        <Grid size={12}>
          <Typography variant="body2" fontWeight="bold" gutterBottom textAlign="center">
            <Link to="/enroll">
              <FormattedMessage id="enroll.enroll_using_email" />
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </AuthFormLayout>
  )
}
